import * as types from '@/store/mutation-types';
import Vue from 'vue';

export default {
  [types.setDiaryEntries](state, list) {
    Vue.set(state, 'currentProjectDiaryEntries', list);
  },
  [types.diaryEntryAddItem](state, { entry, newItem }) {
    entry.diaryEntries.push(newItem);
  },
  [types.diaryEntryRemoveItem](state, { entry, index }) {
    entry.diaryEntries.splice(index, 1);
  },
  [types.diaryEntrySetItemProperties](state, update) {
    Object.assign(update.diaryEntryItem, update.newProperties || {});
  },
  [types.setDiaryEntryProperties](state, update) {
    Object.assign(update.diaryEntry, update.newProperties || {});
  },
  [types.addDiaryEntry](state, { newDiaryEntry }) {
    if (!state.currentProject || !state.currentProject._id === newDiaryEntry.projectId) {
      return;
    }
    if (!state.currentProjectDiaryEntries.find((p) => p._id === newDiaryEntry._id)) {
      state.currentProjectDiaryEntries.push(newDiaryEntry);
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/diaryEntry/diaryEntryMutations.js